/** Chaves de cache do TanStack Query em um unico lugar. */
export const queryKeys = {
  pipelines: ['pipelines'] as const,
  opportunities: ['opportunities'] as const,
  opportunitiesByContact: (contactId: string) => ['opportunities', { contactId }] as const,
  contacts: ['contacts'] as const,
  contact: (id: string) => ['contacts', id] as const,
  patient: (contactId: string) => ['patients', contactId] as const,
  clinicalAccessLog: ['patients', 'access-log'] as const,
  /**
   * ATENCAO ao mexer nestas tres chaves.
   *
   * `['conversations']` e prefixo de `['conversations', id, 'messages']`, entao
   * invalidar a lista invalidava TAMBEM toda thread aberta. Com o socket
   * derrubando as mesmas chaves a cada evento, uma acao simples da equipe
   * (assumir, responder, devolver) disparava dezenas de buscas — o suficiente
   * para bater no limite de requisicoes e a tela ficar com estado velho.
   *
   * Por isso a lista tem segmento proprio: invalidar a lista mexe so na lista.
   */
  conversationList: ['conversations', 'list'] as const,
  conversation: (id: string) => ['conversations', 'item', id] as const,
  messages: (conversationId: string) =>
    ['conversations', 'item', conversationId, 'messages'] as const,
  handoffContext: (conversationId: string) =>
    ['conversations', 'item', conversationId, 'handoff-context'] as const,
  /** Prefixo para quando realmente se quer derrubar tudo de conversas. */
  conversationsAll: ['conversations'] as const,
  activities: ['activities'] as const,
  activitiesByContact: (contactId: string) => ['activities', { contactId }] as const,
  agents: ['agents'] as const,
  /** ASSISTENTES WOW - a conversa de configuracao e as sugestoes dela. */
  agentSetup: ['agent-setup'] as const,
  configSetup: ['config-setup'] as const,
  /** CONVERSA CENTRAL - a lista de recentes e cada conversa. */
  /** INICIO - as prioridades do dia, com dispensa por pessoa. */
  priorities: ['priorities'] as const,
  rimatiChats: ['rimati-chat'] as const,
  rimatiChat: (id: string) => ['rimati-chat', id] as const,
  appointments: ['appointments'] as const,
  waitlist: ['appointments', 'waitlist'] as const,
  availability: ['appointments', 'availability'] as const,
  availabilityRules: ['appointments', 'rules'] as const,
  clinicServices: ['appointments', 'services'] as const,
  professionals: ['appointments', 'professionals'] as const,
  clinicalResources: ['appointments', 'resources'] as const,
  knowledge: ['knowledge'] as const,
  channels: ['channels'] as const,
  diagnostics: ['diagnostics'] as const,
  onboarding: ['onboarding'] as const,
  plataformaVisao: ['plataforma', 'visao'] as const,
  plataformaAtivacao: ['plataforma', 'ativacao'] as const,
  plataformaFila: ['plataforma', 'fila'] as const,
  plataformaIncidentes: ['plataforma', 'incidentes'] as const,
  plataformaSugestoes: ['plataforma', 'sugestoes'] as const,
  meusRelatos: ['suporte', 'meus'] as const,
  capabilityHealth: ['diagnostics', 'health'] as const,
  integrationHomologations: ['diagnostics', 'integration-homologations'] as const,
  externalReadiness: ['diagnostics', 'external-readiness'] as const,
  users: ['users'] as const,
  followups: ['followups'] as const,
  automations: ['automations'] as const,
  dashboard: (period: string) => ['dashboard', period] as const,
  insights: (period: string) => ['insights', period] as const,
  mediaAnalytics: (period: string, kind: string, state: string) =>
    ['dashboard', 'media', period, kind, state] as const,
  /**
   * Prefixos usados para invalidar TODOS os periodos de uma vez.
   * A secao 7.3 e explicita: nao existe evento de contador; o que chega e o
   * evento de dominio, e o frontend descarta o que ele afeta.
   */
  analytics: [['dashboard'], ['insights']] as const,
};
